import React from "react";

export default function Html() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="html">
      <path
        fill="#E44D26"
        d="M3.345 21.601 1.419 0h21.162l-1.928 21.597L11.987 24l-8.642-2.399z"
      ></path>
      <path
        fill="#F16529"
        d="m12 22.164 7.003-1.941L20.65 1.766H12v20.398z"
      ></path>
      <path
        fill="#EBEBEB"
        d="M12 9.778H8.494l-.242-2.713H12V4.416H5.357l.063.71.651 7.301H12V9.778zm0 6.88-.012.003-2.95-.797-.189-2.113H6.19l.371 4.16 5.427 1.506.012-.003v-2.756z"
      ></path>
      <path
        fill="#FFF"
        d="M11.991 9.778v2.649h3.262l-.308 3.436-2.955.797v2.756l5.431-1.505.04-.448.623-6.975.065-.711h-.714l-5.444.001zm0-5.362v2.649h6.399l.053-.596.121-1.343.063-.711-6.636.001z"
      ></path>
    </svg>
  );
}
